import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TLinkField, TSitecoreContext } from '../../../types/sitecore.types';
import {
  TCHHomeProductBackgroundImage,
  TCHHomeProductDashFields,
  TCHHomeProductDashLinesItem,
  TCHProductDashLinesItem,
  TCHHomeProductDashParams,
  TCHHomeProductDashProps,
} from '../types/productDashboard.types';

export class CHHomeProductDashModel {
  public readonly params?: TCHHomeProductDashParams;
  public readonly isApiEmpty?: boolean;
  private readonly fields?: TCHHomeProductDashFields;
  private readonly rendering?: ComponentRendering;
  private readonly context?: TSitecoreContext;

  constructor(props: TCHHomeProductDashProps) {
    this.fields = props?.fields;
    this.params = props?.params;
    this.context = props?.sitecoreContext;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get baseUrl(): string {
    return this.fields?.itemData?.fields?.productsItemUrl ?? '';
  }

  get productLineItems(): Array<TCHProductDashLinesItem> {
    if (this.fields?.apiData?.items && this.fields?.apiData?.items?.length > 0) {
      return (
        this.fields?.apiData?.items?.map((item) => {
          return {
            title: item.title,
            titleUrl: item.titleUrl,
            iconAsset: {
              iconKey: item.iconAsset?.title,
              iconAlt: item.iconAsset?.alt,
              iconUrl: item.iconAsset?.full,
            },
          } as TCHProductDashLinesItem;
        }) || []
      );
    }
    return [];
  }

  get Items(): Array<TCHHomeProductDashLinesItem> {
    return this.fields?.apiData?.items || [];
  }

  get viewLinkData(): TLinkField | undefined {
    if (!this.fields?.itemData?.fields?.customParams?.viewLinkData) return undefined;
    return {
      value: this.fields?.itemData?.fields?.customParams?.viewLinkData,
    };
  }

  get findProductLinkData(): TLinkField | undefined {
    if (!this.fields?.itemData?.fields?.customParams?.findProductLinkData) return undefined;
    return {
      value: this.fields?.itemData?.fields?.customParams?.findProductLinkData,
    };
  }

  get desktopImage(): TCHHomeProductBackgroundImage | undefined {
    return this.fields?.itemData?.fields?.imageParameters?.desktopImageData;
  }

  get mobileImage(): TCHHomeProductBackgroundImage | undefined {
    return this.fields?.itemData?.fields?.imageParameters?.mobileImageData;
  }

  get defaultBgDesktopImage(): TCHHomeProductBackgroundImage | undefined {
    return {
      url: this.context?.defaultBackgroundImageParameters?.desktopImageData?.productDashboardEquipment,
    };
  }

  get defaultBgMobileImage(): TCHHomeProductBackgroundImage | undefined {
    return {
      url: this.context?.defaultBackgroundImageParameters?.mobileImageData?.productDashboardEquipment,
    };
  }

  get desktopBgImage(): TCHHomeProductBackgroundImage | undefined {
    return this.desktopImage?.url ? this.desktopImage : this.defaultBgDesktopImage;
  }

  get mobileBgImage(): TCHHomeProductBackgroundImage | undefined {
    return this.mobileImage?.url ? this.mobileImage : this.defaultBgMobileImage;
  }

  get priorModelCTAField(): TLinkField | undefined {
    const priorModelsUrl = this.fields?.itemData?.fields?.priorModelsUrl;
    const priorModelsTitle = this.params?.priorModelsTitle;

    if (priorModelsUrl && priorModelsTitle) {
      return {
        value: {
          href: priorModelsUrl,
          text: priorModelsTitle,
          title: priorModelsTitle,
        },
      };
    }

    return undefined;
  }

  get isHeaderShown(): boolean {
    return !!(
      this.params?.title ||
      this.params?.description ||
      this.viewLinkData?.value?.title ||
      this.viewLinkData?.value?.href ||
      this.priorModelCTAField
    );
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
